import { useIsAuthenticated } from '@zapier/payment/src/hooks/useIsAuthenticated';
import { isBrowser } from '@zapier/payment/src/utils/isBrowser';
import { ApolloInjection } from '@zapier/payment/src/types';

type UserCurrentAccountResult = {
  accountId: number | undefined;
  error: string | undefined;
  isLoading: boolean;
};

type Props = {
  skip?: boolean;
  useQuery?: ApolloInjection['useQuery'];
};

export const useCurrentAccountId = (
  props: Props = {}
): UserCurrentAccountResult => {
  const { isAuthenticated, error, isLoading } = useIsAuthenticated(props);

  const response = {
    accountId: undefined,
    error: error ? 'Error loading current account ID.' : undefined,
    isLoading,
  };

  if (!isAuthenticated || !isBrowser()) {
    return response;
  }

  /**
   * This can actually return a value even if the user isn't logged in.
   * So we need to make sure the user's actually logged in before returning
   * the currentAccountId.
   */
  const currentAccountId = localStorage.getItem('currentAccountId');

  return {
    ...response,
    accountId: currentAccountId ? parseInt(currentAccountId) : undefined,
  };
};
